import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ProductItem from '@/checkout-instore-legacy/cart/components/ProductList/ProductItem'
import {
  changeItemQuantity,
  removeItem,
  changeOffering,
  switchSeller,
} from '@/checkout-instore-legacy/cart/actions'
import { isItemInCheckoutQueueSelector } from '@/checkout-instore-legacy/cart/queue/redux/selectors'
import { productAvailabilitySelector } from '@/checkout-instore-legacy/cart/selectors'
import { updateStock } from '@/checkout-instore-legacy/product/actions'

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {
      loading: isItemInCheckoutQueueSelector(state)(props.item),
      availability: productAvailabilitySelector(state)(props.item),
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeItemQuantity,
      removeItem,
      changeOffering,
      updateStock,
      switchSeller,
    },
    dispatch
  )

export default connect(makeMapStateToProps, mapDispatchToProps)(ProductItem)
